import { RootState, ThunkDispatch } from "core-integration/src/store";
import { getURL } from "core-integration/src/store/urls/reducers";
import { fetchURL } from "core-integration/src/store/urls/thunks";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { INewsApiResponse, INewsItem } from "../utils/contentFeeds";

type UseNewsProviderDataArgs = {
  url: string;
  numberOfArticles: number;
};

export const useNewsProviderData = ({
  url,
  numberOfArticles,
}: UseNewsProviderDataArgs) => {
  const [newsItems, setNewsItems] = useState<INewsItem[] | null>(null);

  const encodedUrl = encodeURIComponent(url);

  const reduxDispatch = useDispatch<ThunkDispatch>();
  useEffect(() => {
    reduxDispatch(fetchURL(encodedUrl));
  }, [reduxDispatch, encodedUrl]);

  const content = useSelector((state: RootState) => getURL(state, encodedUrl));

  useEffect(() => {
    if (!content || !content.text) {
      return;
    }
    try {
      const parsed: INewsApiResponse = JSON.parse(content.text);
      setNewsItems(parsed.results.items.slice(0, numberOfArticles));
    } catch (e) {
      console.error("Error parsing NBA news feed:", e);
    }
  }, [content, numberOfArticles]);

  return { newsItems };
};
